export const EMPRESA_CBN = 3698;
export const EMPRESA_PLASTICO_USR = 6056;